var exports = {
  "a": "Box__z_I2Te",
};

module.exports = exports;
